import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "filter-count",
  class FilterCount extends SearchspringComponent {
    connectedCallback() {
      this.countElement = this.querySelector("[data-filter-count]");
    }

    update(event) {
      if (!event?.detail) {
        return;
      }

      this.render(event.detail);
    }

    render({ filterSummary }) {
      if (!filterSummary) {
        return;
      }

      const count = filterSummary.length;

      this.countElement.textContent = count;
    }
  },
);
